import { ShopifyVariant } from '@/types/product';

export const getNodes = <T>(arr: { edges: Array<{ node: T }> }): Array<T> =>
  arr.edges.map((edge) => edge.node);

export const setDefaultVariantTitle = (v: ShopifyVariant): ShopifyVariant => ({
  ...v,
  title: v.title === 'Default Title' ? 'One Size' : v.title,
});
